/* ----------------- Globals --------------- */
import { isWeb } from "@memorang/helpers/platform";
import { ScrollView } from "react-native";

import { Chip } from "react-native-paper";
/* ----------------- Components --------------- */
import type { QuickActionsChipType } from "../types";
import { useAppTheme } from "../useAppTheme";
import { useDevice } from "../useDevice";
import TooltipWrapper from "./TooltipWrapper";

/* ----------------- Types --------------- */

type Props = {
	quickActionsChips: QuickActionsChipType[];
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
};
export const QuickActionChips = ({
	quickActionsChips,
	handleQuickActionPress,
}: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();
	return (
		<ScrollView
			horizontal
			showsHorizontalScrollIndicator={false}
			contentContainerStyle={{
				gap: 8,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
		>
			{quickActionsChips?.map((chip) => {
				const Content = () => (
					<Chip
						icon={chip.icon}
						mode={chip.selected ? "flat" : "outlined"}
						compact
						textStyle={{ fontSize: theme.fonts.labelLarge.fontSize }}
						selected={chip.selected}
						disabled={chip.disabled}
						style={{
							maxHeight: 32,
							alignItems: "center",
						}}
						onPress={() => {
							handleQuickActionPress(chip.type);
						}}
					>
						{chip.label}
					</Chip>
				);
				return isWeb ? (
					<TooltipWrapper title={chip.tooltip} key={chip.label}>
						<Content />
					</TooltipWrapper>
				) : (
					<Content key={chip.label} />
				);
			})}
		</ScrollView>
	);
};
